export type TabType = 'Departure' | 'Pipe' | 'Return' | 'SubStation';

export interface BaseEntity {
    id: string;
    identifier: string | number;
    name: string;
}

export interface DepartureEntity extends BaseEntity {
    maxOutputFlow: number | null;    // max_output_flow
    profileTMin: number | null;       // profile_tmin
    profileTInter: number | null;     // profile_t_inter
    profileTMax: number | null;       // profile_tmax
    altitude: number;
    latitude: number;
    longitude: number;
}

export interface PipeEntity extends BaseEntity {
    pipeUsage: 'outward' | 'inward' | 'supply' | 'return' | 'unknown' | string;
    realLength: number;
    projectedLength: number;            // read-only
    innerDiameter: number;
    nominalDiameter: number;
    roughnessFactor: number | null;
    heatExchangeCoef: number | null;
    resizable: boolean | string;
}

export interface ReturnEntity extends BaseEntity {
    altitude: number;
    latitude: number;
    longitude: number;
}

export interface SubStationEntity extends BaseEntity {
    status: boolean;
    nominalPower: number;
    nominalPressureLoss: number | null;
    nominalDeltaT: number | null;
    valveMinPressureLoss: number | null;
    consumptionMin: number | null;
    consumptionInter: number | null;
    consumptionMax: number | null;
    deltaTMin: number | null;
    deltaTInter: number | null;
    deltaTMax: number | null;
    tOutMin: number | null;
    tOutInter: number | null;
    tOutMax: number | null;
    tSupplyMax: number | null;
    altitude: number;
    latitude: number;
    longitude: number;
}

export type TabEntities = DepartureEntity | PipeEntity | ReturnEntity | SubStationEntity;

export interface TabData {
    Departure: DepartureEntity[];
    Pipe: PipeEntity[];
    Return: ReturnEntity[];
    SubStation: SubStationEntity[];
}

export interface UndoEntry {
    tabType: TabType;
    rowId: string;
    field: string;
    oldValue: unknown;
}

export const TAB_LABELS: Record<TabType, string> = {
    Departure: 'Departure',
    Pipe: 'Pipe',
    Return: 'Return',
    SubStation: 'SubStation',
};

